import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import info from '../../assets/images/info.svg';
import logo_white from '../../assets/images/logo/chronos_HVIT_logo_CMYK.svg';
import settings from '../../assets/images/settings.svg';
import { PolylineOutlined } from '@mui/icons-material';
import { ConstructionOutlined } from '@mui/icons-material';
import { SettingsOutlined } from '@mui/icons-material';
import { InfoOutlined } from '@mui/icons-material';
import sidebar_icon from '../../assets/images/sidebar_icon.svg';
//import { EscalatorRounded } from "@mui/icons-material"
import SidebarWindow from './SidebarWindow';
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import SidebarState from '../../data/SidebarState';
import NodeInfoState from '../../data/NodeInfoState';

const GraphSidebar = ({graphName, trees, api_switch_graph,sidebarState, setSidebarState, nodeInfoState, nodeInfo, api_get_tree, graphNames, treeCount, nodeCount, get_connected_nodes, hide_subtree, nodeIsParanted}) => {
    const [collapsed, setCollapsed] = useState(true);

    const handleToggleSidebar = useCallback(() => {
      setCollapsed((prevCollapsed) => {
        if (!prevCollapsed) {
          setSidebarState(SidebarState.HIDDEN)
        }
        return !prevCollapsed;
      });
      
    }, []);

    const handleSidebarState = (state) => {
      if (state !== sidebarState) {
        setSidebarState(state)
      } else {
        setSidebarState(SidebarState.HIDDEN)
      }
    }

    const selectedString = (thisState) => {
      if (thisState === sidebarState) {
        return "selected"
      } else {
        return ""
      }
    }


    return (
      <div className='flex-row' style={{position: "relative", zIndex: 6000}}>
      <div className='graph-sidebar-outer'>
      <Sidebar width='270px' backgroundColor="#661e1c" collapsed={collapsed} className="graph-sidebar">
        <Menu>
          <MenuItem
            icon={<img src={sidebar_icon} alt="Info" style={{ width: 20, height: 20 }} />}
            className="menu1"
            onClick={handleToggleSidebar} // Collapse sidebar when clicking the entire item
          >
            <h2 className='bold'>Graph Editor</h2>
          </MenuItem>
          
          <MenuItem
            onClick={() => handleSidebarState(SidebarState.INFO)}
            icon={<InfoOutlined/>}
            className={selectedString(SidebarState.INFO)}
          >
            <span className='font-medium semibold'>Info</span>
          </MenuItem>
          <MenuItem
            onClick={() => handleSidebarState(SidebarState.CONFIGURE)}
            icon={<SettingsOutlined/>}
            className={selectedString(SidebarState.CONFIGURE)}
          >
            <span className='font-medium semibold'>Configure</span>
          </MenuItem>
          <MenuItem
            onClick={() => handleSidebarState(SidebarState.BUILDER)}
            icon={<ConstructionOutlined/>}
            className={selectedString(SidebarState.BUILDER)}
          >
            <span className='font-medium semibold'>Builder</span>
          </MenuItem>
          <MenuItem
            onClick={(e) => {
                const isDisabled = nodeInfoState === NodeInfoState.HIDDEN;
                if (!isDisabled) {
                    handleSidebarState(SidebarState.NODEINFO);
                } else {
                    e.preventDefault(); // Prevents click event
                }
            }}
            icon={<PolylineOutlined />}
            className={`${selectedString(SidebarState.NODEINFO)} ${nodeInfoState === NodeInfoState.HIDDEN ? "disabled" : ""}`}
            style={{
                pointerEvents: nodeInfoState === NodeInfoState.HIDDEN ? "none" : "auto", // Disable interaction
                opacity: nodeInfoState === NodeInfoState.HIDDEN ? 0.5 : 1, // Visual cue
            }}
        >
            <span className="font-medium semibold">Node Info</span>
        </MenuItem>
          <img id="sidebar-logo" src={logo_white} alt="White chronos-logo" />
        </Menu>
      </Sidebar>
    </div>
    
    <SidebarWindow 
      sidebarState={sidebarState} 
      graphName={graphName} 
      trees={trees}
      api_switch_graph={api_switch_graph} 
      api_get_tree={api_get_tree}
      graphNames={graphNames}
      treeCount={treeCount}
      nodeCount={nodeCount}
      nodeInfo={nodeInfo}
      get_connected_nodes={get_connected_nodes}
      hide_subtree={hide_subtree}
      nodeIsParanted={nodeIsParanted}>
    </SidebarWindow>
    </div>
    );
};

export default GraphSidebar;

/*
<section>
        <Routes>
          <Route path="info-sidebar" element={<SidebarWindow background="red"/>} />
          <Route path="configure-sidebar" element={<SidebarWindow background="blue"/>} />
        </Routes>
      </section>
*/